import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Eccellenza from "./sections/Eccellenza";
import Recognition from "./sections/Recognition";
import Specializzazioni from "./sections/Specializzazioni";
import Approccio from "./sections/Approccio";
import Testimonials from "./sections/Testimonials";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Eccellenza />
      <Recognition />
      <Specializzazioni />
      <Approccio />
      <Testimonials />
      <Consultation />
      <Footer />
    </div>;
}